export default {
  es: {
    table: {
      id: "Id",
      status: "Estado",
      date: "Fecha",
      dateShop: "Fecha de Compra",
      dateConsignment: "Fecha Consignación",
      hourConsignment: "Hora Consignación",
      user: "Usuario",
      daterRequest: "Fecha Solicitud",
      observation: "Observación",
      description: "Descripcion",
      value: "Valor",
      bank: "Banco",
      action: "Acción",
      anexo: "Anexo",
      carrier: "Operador",
      client: "Cliente",
      reference: "Referencia Pago",
      payments: "Abonos",
      company: "Empresa",
      image: "Imagen",
      hour: "Hora",
      type: "Tipo",
      url: "Url",
      codPug: "CodPuc",
      nit: "Nit"
    },
    dashboard: {
      last_transactions: `Ultimas transacciones`
    },
    header: {
      home: `Inicio`,
      dashboard: `Tablero`,
      report: `Reportes`,
      consignment: `Consignaciones`,
      contact: `Contacto`,
      settings: `Configuraciones`,
      logout: `Cerrar sesión`,
      api: `API`,
      buy: `Compras`,
      administration: `Administración`,
      wallet: `Cartera`,
      banks: `Bancos`
    },
    footer: {
      rights: `Todos los derechos reservados`
    },

    contact: {
      name: `Nombre`,
      email: `Correo electrónico`,
      cellphone: `Telefono celular`,
      content: `Contenido`,
      contact: `Contactar`
    }
  }
};
